import { render } from "./ChatInput.vue?vue&type=template&id=a7059556&scoped=true&lang=pug"
import script from "./ChatInput.vue?vue&type=script&lang=js"
export * from "./ChatInput.vue?vue&type=script&lang=js"

import "./ChatInput.vue?vue&type=style&index=0&id=a7059556&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7059556"]])

export default __exports__